/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popGameLostPrompt.vue?vue&type=template&id=3315c1f4&scoped=true"
import script from "./popGameLostPrompt.vue?vue&type=script&lang=js"
export * from "./popGameLostPrompt.vue?vue&type=script&lang=js"
import style0 from "./popGameLostPrompt.vue?vue&type=style&index=0&id=3315c1f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3315c1f4",
  null
  
)

export default component.exports